import React, { Component } from 'react'
import { IconButton } from '@material-ui/core';
import { Facebook, Instagram, LinkedIn } from '@material-ui/icons';
export class Footer extends Component {
    render() {
        return (
            <div className="footer">
                <div className="footer-about">
                  <p className="title">Let's Watch</p>
                  <p className="about">Let's Watch is created for the purpose so that you can look at what to watch today containing no ads.
                  This website is designed and developed by Ashish.</p>
                </div>
                <div className="footer-category">
                <p className="title"> Cateogry</p>
                    <ul>
                        <li>
                           Bollywood
                        </li>
                        <li>
                        Hollywood
                        </li>
                        <li>
                        Horror
                        </li>
                        <li>
                        Comedy
                        </li>
                        <li>
                        Action
                        </li>
                    </ul>

                    </div>
                    <div className="footer-social">
                      <p>Follow me on : - </p>
                      <div className="social-logo"><IconButton> <a target="_blank" href="https://www.facebook.com/profile.php?id=100006700786768"><Facebook/></a> </IconButton><IconButton> <a target="_blank" href="https://www.instagram.com/its_me_ashish__/"> <Instagram/></a> </IconButton><IconButton>  <a target="_blank" href="https://www.linkedin.com/in/ashish-kumar-8ba5961b0/"> <LinkedIn/> </a> </IconButton></div>
                    </div>

            </div>
        )
    }
}

export default Footer
